var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvoices(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_585_1960)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.35254 14.8232H7.41136V15.8821H6.35254V14.8232Z",
    fill: "#3F3F46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.4707 14.8232H14.8236V15.8821H8.4707V14.8232Z",
    fill: "#3F3F46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5293 6.35254H11.6469V7.41136H9.5293V6.35254Z",
    fill: "#3F3F46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7061 6.35254H14.8237V7.41136H12.7061V6.35254Z",
    fill: "#3F3F46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.35254 4.23535H10.0584V5.29418H6.35254V4.23535Z",
    fill: "#3F3F46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1172 4.23535H14.8231V5.29418H11.1172V4.23535Z",
    fill: "#3F3F46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.4707 2.11719H12.706V3.17601H8.4707V2.11719Z",
    fill: "#3F3F46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.35254 12.7061H7.41136V13.7649H6.35254V12.7061Z",
    fill: "#3F3F46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.4707 12.7061H14.8236V13.7649H8.4707V12.7061Z",
    fill: "#3F3F46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.35254 10.5879H7.41136V11.6467H6.35254V10.5879Z",
    fill: "#3F3F46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.4707 10.5879H14.8236V11.6467H8.4707V10.5879Z",
    fill: "#3F3F46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.35254 8.4707H7.41136V9.52953H6.35254V8.4707Z",
    fill: "#3F3F46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.4707 8.4707H14.8236V9.52953H8.4707V8.4707Z",
    fill: "#3F3F46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.35254 6.35254H8.47019V7.41136H6.35254V6.35254Z",
    fill: "#3F3F46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8233 0H3.17624C2.00857 0 1.05859 0.949977 1.05859 2.11765V4.23529H4.23506V18H16.9409V2.11765C16.9409 0.949977 15.991 0 14.8233 0ZM2.11742 3.17647V2.11765C2.11742 1.53381 2.59241 1.05882 3.17624 1.05882C3.76008 1.05882 4.23506 1.53381 4.23506 2.11765V3.17647H2.11742ZM15.8821 16.9412H5.29389C5.29389 16.1624 5.29389 2.85678 5.29389 2.11765C5.29389 1.7568 5.20103 1.38889 5.0097 1.05882H14.8233C15.4071 1.05882 15.8821 1.53381 15.8821 2.11765V16.9412Z",
    fill: "#3F3F46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.35254 2.11719H7.41136V3.17601H6.35254V2.11719Z",
    fill: "#3F3F46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7646 2.11719H14.8235V3.17601H13.7646V2.11719Z",
    fill: "#3F3F46"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_585_1960"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoices);
export default __webpack_public_path__ + "static/media/invoices.dafabe6ed38a9c46827996f3d081adb5.svg";
export { ForwardRef as ReactComponent };